import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value?: number) {
  const v = value ?? 0
  return v.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
}